// i18n area 'backups' — locale es-ES (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.es-ES.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 archivio→«copia de configuración» (#247).
import type { enUS } from './backups'

export const esES: typeof enUS = {
  ckpt: {
    contents: 'Acepta',
    contentsHint:
      'Qué puede aterrizar aquí. «Checkpoints» es la configuración del clúster, «Copias de datos» son las copias de las VM: las dos lecturas se componen, un destino puede aceptar ambas.',
    content: { checkpoints: 'Checkpoints', backups: 'Copias de datos' },
    destinationsTitle: 'Destinos de backup',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Restauración',
    addDestination: 'Añadir destino',
    addDestinationTitle: 'Añadir destino de backup',
    editDestinationTitle: 'Editar destino',
    storage: 'Storage',
    storageHint:
      'Un storage dir-like (dir/NFS/CIFS/CephFS) — los artefactos son ficheros normales bajo el namespace de la plataforma.',
    schedule: 'Planificación',
    scheduleNone: 'Solo manual',
    scheduleHourly: 'Cada hora',
    scheduleDaily: 'Diaria',
    scheduleWeekly: 'Semanal',
    scheduleHour: 'Hora',
    scheduleWeekday: 'Día',
    scheduleHint:
      'Los checkpoints planificados no tienen un operador que teclee la masterpass: los secretos del keystore se empaquetan como placeholders.',
    retention: 'Retention',
    retentionHint:
      'Cuántos checkpoints planificados conservar — el sweeper elimina los más antiguos por encima del recuento. Los checkpoints manuales y pre-restauración nunca se eliminan.',
    paused: 'En pausa',
    pausedHint:
      'El blackout del operador: mientras está en pausa, en este destino no se planifica ni se poda nada — policies de datos y checkpoints por igual. Las ejecuciones en curso no se tocan nunca.',
    orphanRuns: '{n} ejecuciones huérfanas',
    orphanRunsHint:
      'Ejecuciones planificadas de policies que ya no existen en este destino: ninguna retención las gobierna — nunca contadas ni podadas — y solo se borran a mano. La lente «backups» de tvirt diagnose nombra las policies eliminadas.',
    rescan: 'Readoptar artefactos',
    rescanTitle: 'Readopción de artefactos de {name}',
    rescanHint:
      'Reconstruye el catálogo de copias (VM/CT/App) a partir de los manifiestos de los artefactos presentes en el destino. Las filas existentes nunca se tocan; las copias de políticas desconocidas quedan huérfanas (nunca se podan automáticamente). El gesto tras una restauración bootstrap.',
    masterpassDrWarning:
      'Escenario de desastre: los discos LUKS solo vuelven desde un checkpoint CON masterpass. Los checkpoints programados empaquetan marcadores — toma periódicamente un checkpoint manual con masterpass.',
    policy: {
      title: 'Policies de backup de datos',
      hint: 'Policies con nombre: qué objetos (kind, tags, scopes), cada cuánto, cuándo puede arrancar una ejecución y cuántas copias conservar. El gesto de alistamiento queda en manos del propietario del objeto: los tags se asignan sobre su propio scope.',
      add: 'Añadir policy',
      column: 'Policies de datos',
      name: 'Nombre',
      nameHint:
        'Etiqueta de la policy, única en el destino. Las ejecuciones siguen el id estable de la policy: renombrar es gratis; borrarla deja huérfanas sus ejecuciones (ya no se cuentan ni se podan).',
      kindLocked: 'La familia de objetos de una policy existente no se cambia: crea una policy nueva.',
      kindLabel: 'Objetos',
      kind: { vm: 'Máquinas virtuales', ct: 'Containers', app: 'Apps' },
      tags: 'Selector de tags',
      tagsHint: 'Pares tag=valor separados por comas, en AND. Tags y scopes vacíos no seleccionan nada — nunca «todo».',
      scopes: 'Scopes',
      scopesHint: 'Rutas de scope (subárboles), separadas por comas, en OR entre sí.',
      windowStart: 'Ventana desde',
      windowEnd: 'Ventana hasta',
      windowHint:
        'Ventana de ejecución (HH:MM, hora local; un inicio más allá del fin salta la medianoche). Gobierna solo el ARRANQUE: una ejecución que se pasa nunca se mata.',
      mode: 'Modo',
      modeHint:
        'El incremental cabalga sobre la familia de series; una serie rota degrada a full, contado en el diario.',
      modeFull: 'Full',
      modeIncremental: 'Incremental',
      requireQuiesce: 'Exigir quiesce (guest agent)',
      paused: 'Policy en pausa',
      retentionNone: 'Conservar todo',
      retentionCount: 'Recuento',
      retentionGfs: 'Anillos GFS',
      gfs: { keepLast: 'Últimos', daily: 'Diarios', weekly: 'Semanales', monthly: 'Mensuales', yearly: 'Anuales' },
      gfsHint:
        'Por cada anillo se conserva el backup más reciente de cada uno de los últimos N periodos. Un backup conservado mantiene viva toda su cadena — nunca una base con huérfanos.',
      lastRun: 'Última ejecución',
      neverRan: 'nunca ejecutada'
    },
    lastCheckpoint: 'Último checkpoint',
    neverRun: 'Nunca creado',
    createNow: 'Crear checkpoint',
    createNowTitle: 'Crear checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Protege los valores secretos del keystore (argon2id → AES-256-GCM, por valor). Nunca se guarda: consérvela — sin ella, una restauración produce placeholders en lugar de los secretos reales.',
    masterpassEmptyHint: 'Deje vacío para empaquetar placeholders explícitos en lugar de los secretos.',
    createStarted: 'Checkpoint en curso…',
    destinationInUseError: "'{name}' aún contiene checkpoints — elimínelos primero.",
    origin: 'Origen',
    originManual: 'manual',
    originSchedule: 'planificado',
    originPreRestore: 'pre-restauración',
    originPreChange: 'pre-modificación',
    preChangeRetention: 'Checkpoints pre-modificación',
    preChangeRetentionHint:
      'Vacío = desactivado. La primera escritura de configuración tras un periodo de calma congela aquí el estado anterior (origen pre-modificación); se conservan los más recientes hasta el recuento — retención propia, podable.',
    diffTitle: 'Vista previa de los cambios',
    diffFailed: 'Vista previa fallida',
    diffRetry: 'Reintentar',
    diffCounts: '{changed} por modificar · {missing} por crear · {extra} sobrantes · {equal} idénticos',
    diffChanged: 'cambia',
    diffMissing: 'se crearía',
    diffExtra: 'se eliminaría',
    diffJsonb: 'referencias jsonb no verificables antes de aplicar',
    diffSecret: 'campos sellados, no comparables',
    diffMore: '{n} más…',
    diffNeeded: 'El inicio se arma cuando la vista previa refleja la selección.',
    phase: 'Estado',
    phaseRunning: 'en curso',
    phaseComplete: 'completo',
    phaseError: 'error',
    secrets: 'Secretos',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Tamaño',
    created: 'Creado',
    destination: 'Destino',
    download: 'Descargar .tvbk',
    deleteCheckpoint: 'Eliminar checkpoint',
    noCheckpoints: 'Ningún checkpoint — cree uno desde un destino.',
    families: 'Familias',
    generation: 'Generación',
    completedAt: 'Completado el',
    errorDetail: 'Detalle del error',
    manifest: 'Manifest',
    restoreHint: 'Suba un artefacto .tvbk: el explorer muestra qué contiene, luego elija qué restaurar y cómo.',
    uploadFile: 'Subir un fichero .tvbk',
    uploading: 'Subiendo…',
    uploadFailed: 'No se pudo abrir el artefacto',
    explorerTitle: 'Contenido del checkpoint',
    checkpointFrom: 'Checkpoint del clúster {cluster}, creado el {when} ({origin}, generación {generation})',
    otherCluster:
      'Este checkpoint proviene de OTRO clúster ({cluster}) — la restauración cross-cluster llega en un round futuro.',
    encrypted: 'cifrado',
    objectsCount: '{n} objetos',
    mode: 'Modo',
    modeMerge: 'Merge — reconcilia: upsert de los seleccionados, no borra nada',
    modeOverwrite:
      'Overwrite — gana el checkpoint: una familia seleccionada por completo se sustituye entera (las filas actuales ausentes del checkpoint mueren)',
    restoreMasterpassHint:
      'La masterpass con la que se creó el checkpoint. Sin ella, los secretos cifrados se restauran como placeholders explícitos.',
    checkMasterpass: 'Verificar',
    masterpassOk: 'Masterpass correcta',
    masterpassWrong: 'Masterpass errónea',
    parachuteDestination: 'Destino paracaídas',
    parachuteHint: 'Antes de tocar cualquier fila, el task crea aquí un checkpoint automático pre-restauración.',
    summaryTitle: 'Qué va a pasar',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'familia entera',
    summaryObjects: '{n} objetos seleccionados',
    confirmHint:
      'Escriba el nombre del clúster ({name}) para confirmar — una restauración reescribe la configuración declarada.',
    confirmField: 'Nombre del clúster',
    startRestore: 'Restaurar',
    restoreRunning: 'Restauración en curso…',
    restoreDone: 'Restauración completada — los reconcilers convergen sobre la nueva declaración.',
    restoreFailed: 'La restauración ha fallado',
    discard: 'Descartar',
    selectionEmpty: 'Seleccione al menos una familia o un objeto.'
  },

  backup: {
    intro: {
      title: 'Backup de los datos de VM y containers',
      subtitle: 'Los ladrillos que usa el software de backup externo',
      whatItIs:
        'TVirt expone cuatro primitivas: snapshots quiesced, change tracking por disco, export NBD de solo lectura y export de la configuración. De manejarlas se encargan Veeam, Bacula, Acronis y compañía.',
      whatItIsNot:
        'TVirt no es un producto de backup: no planifica nada, no aplica retención y no conserva ninguna copia de sus datos. La retención, los catálogos y las políticas de restauración quedan en el software que ya usa.'
    },
    cbt: {
      title: 'Seguimiento de cambios',
      colVm: 'VM',
      colDisk: 'Disco',
      colState: 'Estado',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Observado',
      colChangeId: 'Change ID',
      colMechanic: 'Mecánica',
      stateActive: 'Activo',
      stateInactive: 'Inactivo',
      stateInconsistent: 'Incoherente — la próxima copia debe ser completa',
      stateBroken: 'Cadena rota — desactive y vuelva a activar como cadena nueva',
      stateSnapshots: 'Siempre activo — delta entre snapshots',
      stateUnavailable: 'No disponible en este disco',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff de snapshots Ceph',
        'lvm-thin-delta': 'Delta del thin pool',
        none: 'Ninguna'
      },
      empty:
        'Ningún disco de VM. El seguimiento se lee por disco: actívelo en un disco qcow2 o tome snapshots en rbd/SAN.',
      chainBroken: 'Cadena rota',
      chainBrokenText:
        'Rota por un {reason}: {bitmaps}. Desactive la bitmap (la cadena se perdió, la próxima copia es completa) y vuelva a activarla como cadena nueva.',
      lineages: 'Épocas',
      epochFrozen: 'congelada en el snapshot {snapshot}',
      epochLost: 'perdida ({cause})',
      epochRecording: 'grabando en la cabeza',
      milestones: 'Hitos (snapshots)',
      enable: 'Activar el seguimiento',
      disable: 'Desactivar',
      reset: 'Reiniciar',
      changedAreas: 'Áreas cambiadas',
      denied: 'No tiene permiso en esta VM',
      enableTitle: 'Activar el seguimiento de cambios',
      disableTitle: 'Desactivar el seguimiento de cambios',
      resetTitle: 'Reiniciar la bitmap',
      areasTitle: 'Áreas cambiadas',
      bitmapName: 'Nombre de la bitmap',
      bitmapNameHint: 'Un nombre propio: tvirt- y tvbk- son de la plataforma',
      granularity: 'Granularidad (bytes)',
      granularityHint: 'Una potencia de dos; 65536 por defecto',
      bitmap: 'Bitmap',
      disableHint: 'Elimina la bitmap y todo su historial de épocas: la próxima copia debe ser completa.',
      resetHint: 'Vacía la bitmap — una base nueva: un change ID anterior ya no es componible.',
      areasFrom: 'Desde el snapshot',
      areasTo: 'Hasta el snapshot',
      areasRun: 'Calcular',
      areasResult: '{count} áreas cambiadas, {bytes}',
      areasEmpty: 'Ninguna área cambiada entre los dos snapshots',
      areasZero: 'ceros',
      areasMore: 'se muestran las primeras {shown} de {count}',
      submit: 'Confirmar',
      error: 'La acción de seguimiento falló'
    },
    exports: {
      title: 'Exports NBD abiertos',
      colVm: 'VM',
      colDisk: 'Disco',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Fase',
      colNode: 'Nodo',
      colEndpoint: 'Endpoint',
      colExpires: 'Caduca',
      colCreated: 'Abierto',
      colError: 'Error',
      phase: {
        preparing: 'Preparando',
        ready: 'Listo',
        closed: 'Cerrado',
        error: 'Fallido'
      },
      expiresIn: 'en {minutes} min',
      expired: 'caducado',
      empty: 'Ningún export. Una sesión de lectura sirve un disco en un snapshot a un cliente NBD; una de escritura llena un disco virgen de una VM apagada. Ambas mueren al vencer.',
      endpointHint: 'TLS con la CA del clúster; el nombre del export es el ticket — muere con la sesión',
      closeDenied: 'No tiene permiso para cerrar exports de esta VM',
      open: 'Abrir export NBD',
      openTitle: 'Abrir un export NBD',
      openDisk: 'Disco',
      openBitmap: 'Bitmap (opcional)',
      openBitmapHint:
        'Publica la época de esa bitmap congelada en este snapshot como meta-context de los extents sucios (solo discos qcow2)',
      openTtl: 'Duración (minutos)',
      openSubmit: 'Abrir',
      openError: 'No se pudo abrir el export',
      colMode: 'Modo',
      mode: {
        read: 'Lectura',
        write: 'Escritura'
      },
      caCertificate: 'CA del clúster',
      caCopy: 'Copiar PEM',
      caDownload: 'Descargar ca-cert.pem',
      caHint: 'Escribe el PEM en ca-cert.pem dentro de una carpeta privada y conecta con nbds://…?tls-certificates=<carpeta> (nbdcopy, nbdinfo) o --object tls-creds-x509,dir=<carpeta>,endpoint=client (qemu-img)',
      caAbsent: 'La sesión no lleva la CA (sin PKI)',
      openWrite: 'Abrir export de escritura',
      openWriteTitle: 'Abrir un export de escritura',
      openWriteIntro: 'El disco debe ser virgen: nacido vacío, nunca escrito, sin snapshot; la VM apagada. La restauración LLENA el disco, no lo repara. Mientras la sesión esté abierta la VM no arranca, no hace snapshot, no se clona y el disco no se mueve.',
      openWriteSubmit: 'Abrir',
      openWriteError: 'No se pudo abrir el export de escritura',
      openWriteDenied: 'No tienes el permiso vm.restore.data en esta VM',
      openWriteStopped: 'Apaga la VM para abrir un export de escritura',
      fromDescription: 'Crear VM desde description',
      fromDescriptionTitle: 'Crear una VM desde una description',
      fromDescriptionIntro: 'La description de export-vm-meta vuelve como VM apagada con los discos vacíos de la geometría descrita — lista para los exports de escritura, disco a disco. Los bytes no pasan por aquí: los lleva restore-disk (CLI) o el cliente NBD del producto de backup.',
      fromDescriptionDoc: 'Description (JSON)',
      fromDescriptionDocHint: 'Pega el documento de export-vm-meta, o elige el archivo',
      fromDescriptionFile: 'Elegir archivo…',
      fromDescriptionInvalid: 'El texto no es un documento JSON',
      fromDescriptionName: 'Nombre de la VM nueva',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Tu scope de partida',
      fromDescriptionStorage: 'Storage de los discos',
      fromDescriptionStorageHint: 'Cada disco nace aquí, en el formato por defecto del storage',
      fromDescriptionMetadataStorage: 'Storage de los metadatos',
      fromDescriptionSameAsStorage: 'El mismo de los discos',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Sin bridge ni red la VM nace sin tarjetas',
      fromDescriptionNetwork: 'Red lógica (fabric/red)',
      fromDescriptionSubmit: 'Crear',
      fromDescriptionError: 'No se pudo crear la VM',
      fromDescriptionDone: 'VM creada: {name}',
      fromDescriptionOpen: 'Abrir la VM',
      fromDescriptionDenied: 'No tienes el permiso vm.create',
      fromDescriptionStillRunning: 'La creación sigue en curso: se sigue esperando'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Copias de datos de las VM',
      titleOnVm: 'Copias de datos',
      empty:
        'Ninguna copia. Una copia lleva los discos, el varstore UEFI y el estado del vTPM a un destino, y sobrevive a la VM.',
      colVm: 'VM',
      colCreated: 'Realizada el',
      colPhase: 'Resultado',
      colDestination: 'Destino',
      colContains: 'Contenido',
      colSize: 'Tamaño',
      colOrigin: 'Origen',
      colMode: 'Tipo',
      retentionChip: 'Retención',
      retentionHint:
        'La retención del destino puede borrar esta copia sin preguntar: nació de una planificación. Las copias manuales nunca se barren.',
      policyRemoved: 'Policy eliminada: {name}',
      policyRemovedHint:
        'La policy que planificó este backup ya no existe: ninguna retención lo gobierna (nunca se poda automáticamente) — bórralo a mano cuando ya no haga falta.',
      phase: {
        running: 'En curso',
        complete: 'Completada',
        error: 'Fallida'
      },
      origin: {
        manual: 'Manual',
        schedule: 'Planificada'
      },
      mode: {
        full: 'Completa',
        incremental: 'Incremental'
      },
      contains: {
        disks: 'Discos',
        varstore: 'Varstore UEFI',
        vtpm: 'Estado vTPM',
        snapshots: 'Instantáneas'
      },
      vmState: {
        stopped: 'VM apagada',
        running: 'VM encendida (en caliente)'
      },
      artifactClass: { metadata: 'Metadatos', data: 'Datos', secret: 'Secreto' },
      detail: {
        tabOverview: 'Resumen',
        tabArtefact: 'Artefacto',
        id: 'Identificador',
        scope: 'Ámbito',
        vmState: 'Estado de la VM al copiar',
        pointInTime: 'Instante de los datos',
        completedAt: 'Concluida el',
        node: 'Nodo que copió',
        error: 'Error',
        path: 'Carpeta en el almacenamiento',
        checksum: 'sha256 del manifest',
        secretsExposed: 'Material sensible en claro',
        secretsExposedYes: 'Sí — el destino no cifra',
        secretsExposedNo: 'No',
        baseBackup: 'Copia base',
        tabManifest: 'Manifest',
        manifestHint:
          'El índice en claro del artefacto: un fichero por fila con su sha256. La carpeta se verifica incluso sin TVirt — bastan qemu-img, tar y jq.',
        manifestEmpty: 'El manifest no enumera ficheros.',
        manifestError: 'El manifest no se puede leer',
        colEntry: 'Fichero',
        colClass: 'Clase',
        colSha: 'sha256'
      },
      create: {
        action: 'Copiar ahora',
        title: 'Copiar ahora',
        submit: 'Iniciar la copia',
        destination: 'Destino',
        destinationHint: 'Solo los destinos que aceptan copias.',
        noDestinations: 'Ningún destino acepta copias: crea uno en Sistema → Checkpoints.',
        contentsHint:
          'Viajan todos los discos, el varstore UEFI y el estado del vTPM. Los dos últimos son la clave: un guest sellado debe volver a arrancar.',
        error: 'La copia no ha arrancado',
        stillRunning: 'Copia aún en curso — continúa aunque cierres.',
        vmRunning:
          'La VM está {phase}: la copia necesita una VM estable — apagada para la copia en frío, encendida para la copia en caliente.'
      },
      restore: {
        action: 'Restaurar',
        title: 'Restaurar',
        intro:
          'La restauración es irreversible. Elige adónde vuelven los datos: a una máquina nueva o encima de la de partida.',
        modeNewVm: 'Restaurar en una VM NUEVA',
        modeNewVmHint:
          'No toca nada de lo que existe — es la opción con la que se verifica una copia. Identificador nuevo y MAC recién acuñadas.',
        modeOver: 'Sobrescribir la VM de partida',
        modeOverHint: 'Destruye los datos actuales de la VM destino, sin vuelta atrás. La VM debe estar apagada.',
        newName: 'Nombre de la nueva VM',
        newNameHint: 'Debe estar libre en el ámbito de destino.',
        storage: 'Almacenamiento de los discos',
        storageHint:
          'Obligatorio: el manifest registra el tamaño y el formato de un disco, nunca el almacenamiento del que venía.',
        metadataStorage: 'Almacenamiento de varstore y vTPM',
        metadataStorageHint: 'Dónde aterrizan la identidad UEFI y el estado del vTPM.',
        sameAsStorage: 'El mismo de los discos',
        bridge: 'Bridge del host',
        bridgeHint:
          'Cada tarjeta registrada vuelve en este bridge con una MAC nueva. Vacío, la VM nace sin tarjetas — el valor por defecto más seguro.',
        overwriteTitle: 'Estás a punto de sobrescribir esta VM',
        overwriteName: 'Nombre',
        overwriteId: 'Identificador',
        overwriteDisks: 'Discos que se reescribirán',
        overwriteNoDisks: 'Ningún disco.',
        overwriteKeeps:
          'Quedan intactos identificador, nombre, ámbito, tarjetas de red y MAC: una copia son los DATOS, la configuración es el checkpoint.',
        confirmField: 'Nombre de la VM',
        confirmHint: 'Escribe {name} para confirmar.',
        targetLoading: 'Leyendo la VM destino…',
        targetRunning:
          'La VM destino está {phase}: la restauración reescribe los bytes bajo el guest, así que la quiere apagada.',
        targetGone: 'La VM de partida ya no se puede leer: queda la restauración en una VM nueva.',
        onlyComplete: 'La copia está {phase}: solo una copia completada puede restaurar.',
        submitNewVm: 'Restaurar en la nueva VM',
        submitOver: 'Sobrescribir',
        error: 'La restauración no ha arrancado',
        stillRunning: 'Restauración aún en curso — copiar discos enteros lleva tiempo.'
      }
    },
    guest: {
      title: {
        ct: 'Copias de datos de los contenedores',
        app: 'Copias de datos de las App'
      },
      tabTitle: 'Copias',
      empty: 'Sin copias. Una copia lleva los datos persistentes a un destino y sobrevive a su objeto.',
      colSubject: {
        ct: 'Contenedor',
        app: 'App'
      },
      colCreated: 'Realizada',
      colPhase: 'Resultado',
      colDestination: 'Destino',
      colContains: 'Contenido',
      colSize: 'Tamaño',
      colOrigin: 'Origen',
      policyRemoved: 'Policy eliminada: {name}',
      policyRemovedHint:
        'La policy que planificó este backup ya no existe: ninguna retención lo gobierna (nunca se poda automáticamente) — bórralo a mano cuando ya no haga falta.',
      phase: {
        running: 'En curso',
        complete: 'Completada',
        error: 'Fallida'
      },
      origin: {
        manual: 'Manual',
        schedule: 'Programada'
      },
      state: {
        stopped: 'Objeto apagado',
        running: 'Objeto encendido (congelado)'
      },
      contains: {
        rootfs: 'Árbol rootfs',
        config: 'Configuración',
        volumes: 'Volúmenes persistentes',
        root: 'Root persistente'
      },
      artifactClass: {
        metadata: 'Metadatos',
        data: 'Datos',
        secret: 'Secreto'
      },
      create: {
        action: 'Hacer copia ahora',
        title: 'Nueva copia',
        submit: 'Iniciar la copia',
        error: 'La copia no ha arrancado',
        destination: 'Destino',
        destinationHint: 'Solo los destinos que aceptan copias de datos.',
        noDestinations: 'Ningún destino acepta copias de datos: añade «Copias de datos» a un destino.',
        hint: {
          ct: 'Viaja el árbol rootfs entero, fielmente (propietarios numéricos, xattrs, ACL), más la configuración declarada en el manifiesto. Un contenedor encendido se CONGELA durante todo el empaquetado: copia crash-consistent, declarada.',
          app: 'Viajan SOLO los volúmenes persistentes (y la root persistente), más la configuración en el manifiesto. Lo efímero queda excluido por ratificación y el manifiesto lo nombra; los valores env declarados secretos no viajan.'
        },
        stillRunning: 'Copia aún en curso — empaquetar árboles enteros lleva tiempo.'
      },
      detail: {
        tabOverview: 'Resumen',
        tabManifest: 'Manifiesto',
        id: 'Identificador',
        scope: 'Ámbito',
        state: 'Estado en la copia',
        pointInTime: 'Datos al instante',
        completedAt: 'Concluida',
        node: 'Nodo que copió',
        error: 'Error',
        path: 'Carpeta en el almacenamiento',
        checksum: 'sha256 del manifiesto',
        manifestHint:
          'El índice del artefacto: una entrada por archivo con su sha256 — sin los hashes, «la copia está» es un acto de fe.',
        manifestError: 'El manifiesto no se puede leer',
        manifestEmpty: 'Sin artefactos en el manifiesto.',
        colEntry: 'Archivo',
        colClass: 'Clase',
        colSha: 'sha256',
        excluded: 'Excluido por ratificación (no viaja)',
        secretKeys: 'Claves env secretas omitidas (#307) — reintrodúcelas tras una restauración'
      },
      restore: {
        action: 'Restaurar',
        title: 'Restauración',
        submit: 'Restaurar',
        error: 'La restauración no ha arrancado',
        stillRunning: 'Restauración aún en curso — extraer árboles enteros lleva tiempo.',
        onlyComplete: 'La copia está {phase}: solo una copia completada puede restaurar.',
        asNew: {
          ct: 'En un contenedor NUEVO — no destruye nada: el gesto con el que se verifica una copia',
          app: 'En una App NUEVA — no destruye nada: el gesto con el que se verifica una copia'
        },
        over: {
          ct: 'SOBRE el contenedor de origen — se sustituye el árbol rootfs entero',
          app: 'SOBRE la App de origen — se sustituye el contenido de cada volumen persistente'
        },
        name: 'Nombre del nuevo objeto',
        storage: 'Almacenamiento',
        storageHint: 'Dónde aterrizan los datos restaurados — el manifiesto nunca registra el pool perdido.',
        storageDeclared: 'Los almacenamientos declarados en el manifiesto',
        bridge: 'Bridge del host',
        bridgeHint:
          'Cada tarjeta registrada vuelve en este bridge con una MAC nueva. Vacío = nace desconectado, el valor por defecto más seguro.',
        node: 'Nodo',
        nodeHint: 'El miembro en el que renace la App: el nodo es identidad de clúster y nunca llega del manifiesto.',
        secretKeysWarning:
          'Los valores env declarados secretos no viajan en la copia: la copia renacida los quiere reintroducidos (el log del task nombra las claves).',
        overInventory: 'Estás a punto de sobrescribir este objeto',
        confirmType: 'Escribe {name} para confirmar',
        targetGone: 'El objeto de origen ya no se puede leer: queda la restauración como nuevo.',
        targetLoading: 'Leyendo el objeto de destino…',
        targetRunning:
          'El objeto de destino está encendido: la restauración sustituye los bytes bajo el guest y lo quiere apagado.'
      }
    }
  }
}
